import React, { useContext, useState } from "react";
import clienteAxios from "../../../../config/axios";
import AlertaContext from "../../../../Context/Alerta/AlertaContext";
import CalendarioPlus from "../../../components/Calendario/CalendarioPlus";

// MATERIAL
import { makeStyles } from "@mui/styles";
import {
  Box,
  IconButton,
  TextField,
  FormControl,
  InputAdornment,
  Autocomplete,
  Typography,
} from "@mui/material";
import {
  CalendarToday,
  Delete,
  // CloudDownload,
} from "@mui/icons-material";
const useStyles = makeStyles((theme) => ({
  inputPadding: {
    padding: theme.spacing(0.25),
    margin: theme.spacing(0),
    fontSize: ".85rem",
  },

  form20PC: {
    flexGrow: 1,
    width: "17%",

    [theme.breakpoints.down("md")]: {
      padding: "0",
      margin: "2px",
      width: "23%",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "0",
      margin: "2px",
      width: "30%",
    },
  },
  formAllW: {
    flexGrow: 1,
    padding: theme.spacing(0.25),
    margin: theme.spacing(0.25),
    width: "95%",

    [theme.breakpoints.down("md")]: {
      padding: "0",
      margin: "2px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "0",
      margin: "2px",
    },
  },
}));
const Turno = (props) => {
  const { turno, item, setitem, index, estadoRequest, ubicacionesData } = props;
  const clases = useStyles();
  const { mostrarAlerta } = useContext(AlertaContext);
  const [clientesDataIngreso, setclientesDataIngreso] = useState([]);
  const [puestosDataIngreso, setpuestosDataIngreso] = useState([]);
  const [clientesDataSalida, setclientesDataSalida] = useState([]);
  const [puestosDataSalida, setpuestosDataSalida] = useState([]);
  const [openCalendario, setopenCalendario] = useState(false);
  const [focusedDate, setFocusedDate] = useState("");
  return (
    <>
      <Box
        display={"flex"}
        justifyContent="space-between"
        className={clases.formAllW}
        key={turno.id}
      >
        <Typography variant="button" color="primary" fontWeight={"700"}>
          {`Turno #${index + 1}`}
          <IconButton
            size="small"
         
            onClick={() => {
              setitem({
                ...item,
                horarios: item.horarios.filter((item) => {
                  return item.id !== turno.id;
                }),
              });
            }}
          >
            <Delete color="error" />
          </IconButton>
        </Typography>{" "}
      </Box>
      <>{/* INGRESO */}</>
      {/* TURNO */}
      <CalendarioPlus
        mostrarDiasFranco
        propiedad={turno.fechas_milisegundos}
        propiedadDB={turno.fechas_iso}
        focusedDate={focusedDate}
        setFocusedDate={setFocusedDate}
        item={turno}
        setitem={(e) => {
          setitem({
            ...item,
            horarios: item.horarios.map((item) => {
              if (item.id === turno.id) {
                return e;
              } else {
                return item;
              }
            }),
          });
        }}
        TextoPropiedad={"fechas_milisegundos"}
        textoPropiedadDB={"fechas_iso"}
        openCalendario={openCalendario}
        setopenCalendario={setopenCalendario}
      />{" "}
      <FormControl fullWidth className={clases.formAllW}>
        <Autocomplete
          filterOptions={(x) => x}
          options={ubicacionesData.map((item) => {
            return item.ubicacion + "/+/" + item.puesto + "/+/" + item.id;
          })}
          getOptionLabel={(option) => {
            return option.split("/+/")[0];
          }}
          id="controlled-demo"
          value={turno.ubicacion}
          paperprops
          onChange={async (event, newValue) => {
            if (newValue) {
              const options = newValue.split("/+/");
              console.log({ options });
              console.log(turno);

              setitem({
                ...item,
                horarios: item.horarios.map((item) => {
                  if (item.id === turno.id) {
                    return {
                      ...turno,
                      ubicacion: options[0],
                      id_horario_ubicacion: options[2],
                    };
                  } else {
                    return item;
                  }
                }),
              });
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              required
              label={"Ubicación"}
              fullWidth
              // error={error.actaEntDoc}
            />
          )}
        />
      </FormControl>
      <TextField
        className={clases.form20PC}
        multiline
        rows={2}
        size="small"
        label="Fechas"
        value={turno.fechas_iso
          .map(
            (itemFecha) =>
              `${itemFecha.desde
                .substr(0, 16)
                .replace("T", "-")}, ${itemFecha.hasta
                .substr(0, 16)
                .replace("T", "-")}`
          )
          .join(" || ")}
        // name="dia"
        InputProps={{
          endAdornment: (
            <InputAdornment>
              <IconButton
                aria-label=""
                onClick={() => {
                  setopenCalendario(true);
                }}
              >
                <CalendarToday color="secondary" />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </>
  );
};

export default Turno;
